'use strict'

module.exports = (a, b, condition) => condition === 'true' ? a : b

